module.exports = __webpack_public_path__ + "static/fkr-a5cafb3b0f86ecd3c6dd8eff81f74b3e.png";